export default "__VITE_ASSET__4Dj3HFz3__"